import React from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { List, ListItem } from '@material-ui/core';
// import { getShops } from '../../actions/Shop';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '34px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  title: {
    fontWeight: 700,
    fontSize: 24
  },
  buttonsContainer: {
    margin: '32px 15px 36px'
  },
  imageBox: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    gridGap: '39px 40px',
    gridAutoRows: '1fr'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  imageChoose: {
    border: `5px solid ${theme.palette.primary.main}`
  },
  imageNotChoose: {
    border: `5px solid white`
  },
  header: {
    margin: '48px 16px 8px',
    fontSize: 20
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  setPropTypes(propTypes),
  withState('imageChooseId', 'setImageChooseId', 0),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    menuImageSampleList,
    imageChooseId,
    setImageChooseId,
    setPreviewImage,
    handleClose,
    setIsImageDefault,
    setImageError
  }) => {
    const handleAddImage = () => {
      const imageTemp = menuImageSampleList.find(
        image => image.menuImageSampleId === imageChooseId
      ).image;
      setPreviewImage(imageTemp);
      setIsImageDefault(true);
      setImageError('');
      handleClose();
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography className={classes.title}>メニュー画像選択</Typography>
        </div>
        <div className={classes.mainPaper} elevation={1}>
          <Typography className={[classes.title, classes.header]}>
            サンプル画像選択
          </Typography>
          <List component="nav" className={classes.listForm}>
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.imageBox}>
                {menuImageSampleList.map(image => {
                  return (
                    <div
                      key={image.menuImageSampleId}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setImageChooseId(image.menuImageSampleId);
                      }}
                      aria-hidden="true"
                      className={
                        imageChooseId === image.menuImageSampleId
                          ? classes.imageChoose
                          : classes.imageNotChoose
                      }
                    >
                      <img
                        src={image.image}
                        alt="image-menu-sample"
                        className={classes.image}
                        aria-hidden
                      />
                    </div>
                  );
                })}
              </Typography>
            </ListItem>
          </List>
        </div>
        <div className={classes.buttonsContainer}>
          <CancelButton onClickAction={handleClose} color="primary" />
          <ConfirmButton
            consent={imageChooseId}
            onClickAction={handleAddImage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
